/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Overpay_Credit_Exceeds_TenderedInputs */

const vi_error_overpay_credit_exceeds_tendered = /** @type {(inputs: Error_Overpay_Credit_Exceeds_TenderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền ghi vào số dư khách lớn hơn số tiền khách đưa dư. Kiểm tra lại số tiền khách thanh toán.`)
};

/**

* @param {Error_Overpay_Credit_Exceeds_TenderedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_overpay_credit_exceeds_tendered = /** @type {((inputs?: Error_Overpay_Credit_Exceeds_TenderedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Overpay_Credit_Exceeds_TenderedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_overpay_credit_exceeds_tendered(inputs)
});